<template>
  <form class="question-form">
    <div class="grid-row grid-row_md d-flex_wrap mt-8">
      <template v-if="!isAuth">
        <div class="grid-col grid-col_50 grid-col_sm-100 pt-8">
          <input
            type="text"
            class="form-field"
            placeholder="Имя"
            name="name"
            v-model="name"
          />
        </div>

        <div class="grid-col grid-col_50 grid-col_sm-100 pt-8">
          <input
            type="email"
            class="form-field"
            placeholder="Email"
            name="email"
            v-model="email"
          />
        </div>
      </template>

      <div class="grid-col grid-col_100 pt-8">
        <textarea
          name="question"
          class="form-field form-field_text"
          placeholder="Задайте вопрос о товаре"
          @focus="showForm()"
          v-model="question"
          ref="questionField"
        ></textarea>
      </div>
    </div>

    <div class="mt-20">
      <button
        type="button"
        @click="sendReview"
        class="btn btn_lg btn_primary fw-medium btn_px-lg border-radius-md"
      >
        Отправить
      </button>
    </div>
  </form>
</template>

<script>
import { sendReview } from "@/pages/product_card/api/product.api";
import { mapState } from "pinia";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { useReviewsStore } from "@/pages/product_card/stores/store_reviews";

export default {
  name: "QuestionForm",
  data() {
    return {
      name: "",
      email: "",
      question: "",
      isAuth: window.isAuth,
    };
  },
  setup() {
    const storeReviews = useReviewsStore();

    return {
      storeReviews,
    };
  },
  computed: {
    ...mapState(useProductStore, ["getSelectedProduct"]),
  },
  methods: {
    async sendReview() {
      if (this.question.length === 0) return;

      const reviewResponse = await sendReview(
        this.getSelectedProduct.code,
        5,
        this.question,
        undefined,
        "question",
        this.name,
        this.email
      );

      if (reviewResponse?.id > 0) {
        this.$emit("closePopup");
        this.storeReviews.reviewInProcess.sent = true;
      }
    },
  },
  props: {},
};
</script>

<!-- <style lang="scss">
@import "./question-form.scss";
</style> -->
